/** App-wide configuration constants. */

/** Signaling Worker endpoint. Dev uses `wrangler dev` on localhost. */
export const SIGNALING_URL = import.meta.env.DEV
  ? "ws://localhost:8787"
  : "wss://enclave-signaling.debajyoti-saikia-7ae.workers.dev";
// Swap to "wss://signal.enclave.deb0.com" once deb0.com is a zone on this
// Cloudflare account and a custom-domain route is mapped to the Worker.

/**
 * ICE servers — STUN only (direct-only by design). No TURN: the ~10–20% of peers
 * behind symmetric NATs simply fail to connect, which we surface in the UI.
 * To add a fallback later, append Open Relay TURN entries here — nothing else
 * in the app needs to change.
 */
export const ICE_SERVERS: RTCIceServer[] = [
  { urls: "stun:stun.cloudflare.com:3478" },
  { urls: "stun:stun.l.google.com:19302" },
];

/** Transfer tuning. */
export const CHUNK_SIZE = 64 * 1024; // 64 KiB plaintext per chunk
export const BUFFER_HIGH = 8 * 1024 * 1024; // pause sending above this bufferedAmount
export const BUFFER_LOW = 1 * 1024 * 1024; // resume once drained below this

/** How long a created link waits for the other peer before timing out (ms). */
export const RENDEZVOUS_TIMEOUT = 5 * 60 * 1000;

export const SITE_ORIGIN = "https://enclave.deb0.com";

export const CREATOR = {
  name: "Debajyoti Saikia",
  portfolio: "https://deb0.com",
  linkedin: "https://www.linkedin.com/in/debajyotisaikia/",
} as const;
